import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { AiOutlineArrowUp } from 'react-icons/ai';
import { RxCross1 } from 'react-icons/rx';
import { MessageType, showNotification } from '../common/CommonStyle';
import { post, get } from '../../config/dataService/dataService';
import { useLocation } from 'react-router-dom';
import { Button, Form, Input } from 'antd';
import GetReviewImage from './GetReviewImage';
import { useDispatch } from 'react-redux';
import { addCommentData, setActiveEntityId } from '../../redux/notesetting/notesSettingsSlice';

const NoteForm = ({
  onCancel,
  pendingNote,
  noteId,
  defaultInputValue,
  commentId,
  commentBlockId,
  onSubmit,
  isAdmin = false,
}) => {
  const urls = {
    getcommenturl: 'ProofComment/AddUpdateComment',
    getcommentBynoteid: 'ProofComment/GetCommentById',
  };
  const location = useLocation();
  const { imageData } = location.state || {};
  const { coords } = pendingNote || {};
  const inputRef = useRef(null);
  const [isDirty, setIsDirty] = useState(false);
  const [loading, setLoading] = useState(false);
  const [commentsDatafromNoteId, setCommentsDatafromNoteId] = useState([]);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const datacomment = commentsDatafromNoteId.length > 0 ? commentsDatafromNoteId[0] : {};
      const payload = {
        id: datacomment.id || commentBlockId || 0,
        commentId: commentId || 0,
        description: values.description,
        imageId: imageData?.ImageId || datacomment.imageId,
        versionmapingImageId: imageData?.VersionmapingImageId || datacomment.versionmapingImageId,
        proofId: imageData?.ProofId || datacomment.proofId,
        isResolved: false,
        x: coords?.x?.size || datacomment.x,
        y: coords?.y?.size || datacomment.y,
        versionId: imageData?.VersionNo || datacomment.versionId,
        proofWorkflowContactId: isAdmin ? parseInt(localStorage.getItem('USER_ID') || '0') : imageData.ProofContactId,
      };
      const result = await post(urls.getcommenturl, payload);
      dispatch(addCommentData({...result}));
      setTimeout(() => {
        dispatch(setActiveEntityId(noteId));
      }, 2000);

      if (result.flag) {
        form.resetFields();
        setIsDirty(false);
        showNotification(MessageType.Success, result.message);
        onSubmit();
      } else {
        showNotification(MessageType.Error, result.message);
      }
    } catch (error) {
      showNotification(MessageType.CatchError, '');
    }
    setLoading(false);
  };

  useEffect(() => {
    if (noteId) {
      GetcommentByNoteId(noteId);
    }
  }, [noteId]);

  useEffect(() => {
    if (defaultInputValue) {
      form.setFieldsValue({ description: defaultInputValue });
    }
  }, [defaultInputValue, form]);

  const GetcommentByNoteId = async (noteId) => {
    setLoading(true);
    try {
      const response = await get(`${urls.getcommentBynoteid}?id=${noteId}`);
      const responseData = response?.data;
      if (responseData) {
        setCommentsDatafromNoteId(responseData);
      } else {
        console.error('API call unsuccessful:', responseData?.message);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    setLoading(false);
  };

  return (
    <div className="custom-get-review-image-form">
      <Form onFinish={handleSubmit} form={form}>
        <Form.Item name="description" rules={[{ required: true, message: 'Please add a comment' }]}>
          <Input placeholder="Add a comment" />
        </Form.Item>

        {onCancel && (
          <button className="cancel-button" type="button" onClick={onCancel}>
            <RxCross1 color="#fff" />
          </button>
        )}

        <Button htmlType="submit" className={isDirty ? 'active' : ''}>
          <span>
            <AiOutlineArrowUp />
          </span>
        </Button>
      </Form>
    </div>
  );
};

export default NoteForm;
